// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

// base styles
import colors from "assets/mavric-theme/base/colors";
import boxShadows from "assets/mavric-theme/base/boxShadows";
import borders from "assets/mavric-theme/base/borders";

const { white, primary } = colors;
const { xl } = boxShadows;
const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    paper: {
      backgroundColor: primary.main,
      //boxShadow: xl,
      padding: pxToRem(8),
      borderRadius: borderRadius.md,
    },
  },
};

export default popover;
